export default {
    okText: 'Confirm',
    closeText: 'Close',
    cancelText: 'Cancel',
    urgentText: 'Urgent',
    loadingText: 'Loading...',
    resetText: 'Reset',
    searchText: 'Search',
    queryText: 'Query',
    advancedQueryText: 'More Search',
    closeAdvancedQueryText: 'Close More Search',
    editText: 'Edit',
    saveText: 'Save',
    savingText: 'Saving',
    delText: 'Delete',
    bulkDelText: 'Bulk Delete',
    bulkInactiveText: 'Bulk Disable',
    bulkLogoutText: 'Bulk Logout',
    bulkDelCancelText: 'Bulk Cancel',
    bulkDelRestoreText: 'Bulk Release',
    addText: 'Add',
    backText: 'Return',
    discardText: 'Discard',
    settingText: 'Settings',
    settingText1: 'Setting',
    restoreDefaultText: 'Restore Default',
    checkAllText: 'Select All',
    refreshText: 'Refresh',
    operationText: 'Action',
    viewText: 'View',
    changeText: 'Switch',
    currentUserText: 'current user',
    viewMoreText: 'View More',
    markText: 'Scheduled',
    downloadTemplateText: 'Download Template',
    downloadText: 'Download',
    labelDownloadText: 'Label Download',
    batchDownloadText: 'Batch Download',
    importDataText: 'Import Data',
    inputText: 'Please Enter',
    inputPlusText: 'No special characters.',
    chooseText: 'Please Select',
    detailsText: 'Details',
    submitText: 'Submit',
    closeOthersText: 'Close Others',
    closeAllText: 'Close All',
    operationLogText: 'Operation Log',
    logText: 'Log',
    emptyText: 'Clear',
    importText: 'Import',
    exportText: 'Export',
    exportFullText: 'Full Export',
    countryText: 'Country / State',
    cityText: 'City',
    districtNameText: 'Area',
    detailAddressText: 'Detailed Address',
    postcodeText: 'Postcode',
    emptyWarningText: ' Cannot be empty',
    emptyWarningText1: 'Cannot be 0 or empty',
    customerNameText: 'Customer Name',
    clientCodeText: 'Customer Code',
    delegatedOperationText: 'Log in as customer',
    cancelDelegatedOperationText: 'Return to my account',
    delegateOnceText: 'Log in as customer',
    confirmDelegateOperationText: "Log in as {customerName} - {clientCode}? Your actions will affect this customer's data.",
    confirmCancelDelegatedOperationText: 'End this session and return to your own account',
    inputCustomerNameText: 'Please enter customer name',
    confirmOperationText: 'Confirm Operation?',
    langText: 'Language',
    online: 'Online',
    line: 'Offline',
    table: {
        countText: 'No. ',
        statusText: 'Status',
        operationText: 'Action',
        hideSearchText: 'Hide',
        showSearchText: 'Show Search',
        createTimeText: 'Date Created',
        remarkText: 'Remark',
        auditText: 'Review',
        creatorText: 'Created By',
        emptyText: 'No Data Available',
        createdByText: 'Created',
    },
    toast: {
        hintText: 'Tip',
        okText: 'Confirm',
        cancelText: 'Cancel',
        deletionConfirmationText: 'Are you sure you want to delete this data?',
        batchDeleteText: 'Are you sure you want to delete these data in bulk?',
        operationSuccessText: 'Operation Successful',
        hjSuccessText: 'Operation successful. HJ order status will refresh in 5 seconds.',
        delEnabledTipText: 'You have selected data that is currently in use and cannot be deleted.',
        delAllTipText: 'You are deleting the selected data, do you want to continue?',
        continueTipText: 'Continue?',
        AboutToExport: 'Exporting ',
        waitText: ' records, please wait',
        ManualText: 'Click to download the user manual',
        youAreTipText: 'You are',
        youAreDelTipText: 'You are deleting',
        submitSuccessText: 'Submission successful',
        deleteSuccessText: 'Deletion successful',
        login: 'the login account is',
        operationText: 'Operation in progress, do you want to continue?'
    },
    form: {
        oddNumbers: 'Order No.',
        startDateText: 'Start Date',
        endDateText: 'End Date',
        startTimeText: 'Start Time',
        endTimeText: 'End Time',
    },
    personal: {
        title: 'Personal information',
        avatarSetting: 'Change profile picture',
        loginName: 'Login account',
        name: 'Name',
        tenant: 'Belongs to tenant',
        tenantName: 'CSG',
        validityPeriod: 'Valid from',
        APIKey: 'API Key',
        APIbtn: 'Add New API Connection',
        safetySet: 'Security Settings',
        password: 'Password',
        passwordText: 'A high-security password can make your account more secure. We recommend that you regularly change your password and set a password that is at least 6 characters long and includes at least two of the following: letters, symbols, or numbers.',
        hasBeenSet: 'Set',
        notSet: 'Not set',
        revise: 'Modify',
        mobileBinding: 'Mobile binding',
        verified: 'Verified',
        unverified: 'Not verified',
        bind: 'Bind',
        bound: 'Already bound',
        verify: 'Please verify',
        phoneNumber: 'Mobile number',
        phoneNumberText: '(Mobile number can be used for login and password retrieval)',
        emailBinding: 'Email binding',
        email: 'Email',
        emailText: '(Email can be used for login and password retrieval)',
        changePassword: 'Change password',
        originalPassword: 'Old password',
        originalPasswordText: 'Please enter old password',
        newPassword: 'New password',
        newPasswordText: 'Please enter new password',
        checkPass: 'Confirm new password',
        checkPassText: 'Please enter new password again',
        verificationCode: 'Verification code',
        verifyPassword: 'Password verification',
        passwordValidation: 'Password verification',
        enterPasswordText: 'Please enter password',
        passwordErrorMsg1: 'Please enter password again',
        passwordErrorMsg2: 'Passwords entered do not match!',
        emailErrorMsg1: 'Please enter email address',
        emailErrorMsg2: 'Please enter a valid email address',
        sendVerificationCode: 'Send verification code',
        getVerificationCode: 'Get verification code',
        verificationCodeText: 'Please enter verification code',
        phoneErrorMsg: 'Please enter a valid mobile number',
        reacquire: 'Get again',
        avatarErrorMsg1: 'Uploaded image must be in JPG or PNG format!',
        avatarErrorMsg2: 'Uploaded image size cannot exceed 500kb!',
        hasBeenSent: 'Sent',
        sendSuccess: 'Sent successfully',
        cannotExceed: 'The size of cannot exceed',
        UploadAttachments: 'Upload attachments',
        psuploading: 'Can drag and drop images to adjust the order, supports uploading file formats and sizes according to different platforms, with a size not exceeding 5M',
        none: 'This feature is currently under development and we apologize for any inconvenience this may have caused you !'
    },
    errorApi: 'Data Error',
    errorApi2: 'Request timeout, please refresh and try again',
    pendingApi: 'Data is being processed, please check back later'
};
